import BaseActions from '../../../actions/base';
import config from '../../../config';

const base = config;

const actions = new BaseActions({
    path: `${base.root}/sw/actions`,
    type: 'SWALLOW_ACTIONS',
});

export default actions;